module.exports = __webpack_public_path__ + "img/tron-trx-logo.22151066.svg";